import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IAppTerm, IAppTermsModal } from '../types/app-terms.types';

interface TermsInitialState extends BaseDataReducerV2InitialState<IAppTerm> {
  selectedTerm: IAppTerm | null;
  isNeedSaveOrder: boolean;
  currentModal: IAppTermsModal | null;
}

const { initialState, AC, reducer } = basedDataReducerV2<IAppTerm, TermsInitialState>('app-terms');

export const termsInitialState: TermsInitialState = {
  ...initialState,
  perPage: 100,
  selectedTerm: null,
  isNeedSaveOrder: false,
  currentModal: null,
};

export const appTerms = createSlice({
  name: 'appTerms',
  initialState: termsInitialState,
  reducers: {
    setSelectedTerm(state, action: PayloadAction<IAppTerm | null>) {
      state.selectedTerm = action.payload;
    },
    setAppTerms(state, action: PayloadAction<IAppTerm[]>) {
      state.items = action.payload;
    },
    setAppTermsModal(state, action: PayloadAction<IAppTermsModal | null>) {
      state.currentModal = action.payload;
    },
    setIsNeedSaveOrder(state, action: PayloadAction<boolean>) {
      state.isNeedSaveOrder = action.payload;
    },
    clearState(state) {
      state = termsInitialState;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as TermsInitialState, action);
    });
  },
});

export const AppTermsAC = AC;

export const { clearState, setAppTerms, setIsNeedSaveOrder, setAppTermsModal, setSelectedTerm } = appTerms.actions;
